export function hasSubscriptionFeature(projectOrSubscription, feature) {
    const subscription = projectOrSubscription?.subscription ?? projectOrSubscription;
    const currentPackage = subscription?.currentPackage;

    if (!currentPackage) {
        return false;
    }

    if (feature === "mcp_access") {
        return currentPackage.features?.mcp_access === true;
    }

    if (Object.prototype.hasOwnProperty.call(currentPackage.features ?? {}, feature)) {
        return currentPackage.features[feature] === true;
    }

    return true;
}

export function hasSubscriptionCostSource(projectOrSubscription, legacyFeature) {
    const subscription = projectOrSubscription?.subscription ?? projectOrSubscription;
    const currentPackage = subscription?.currentPackage;

    if (!currentPackage) {
        return false;
    }

    if (Object.prototype.hasOwnProperty.call(currentPackage.features ?? {}, "additional_cost_sources")) {
        return currentPackage.features.additional_cost_sources === true;
    }

    if (Object.prototype.hasOwnProperty.call(currentPackage.features ?? {}, legacyFeature)) {
        return currentPackage.features[legacyFeature] === true;
    }

    if (legacyFeature === "affiliate") {
        return currentPackage.allowAffiliateEvaluation !== false;
    }

    return true;
}

export function allowsCampaignBreakdown(projectOrSubscription) {
    const subscription = projectOrSubscription?.subscription ?? projectOrSubscription;
    const currentPackage = subscription?.currentPackage;
    if (!currentPackage) {
        return false;
    }

    const marketingPerformance = currentPackage.features?.marketing_performance;

    return marketingPerformance === undefined
        || ["campaign_adset_ad", "campaign_product_order", "ads_creatives_audiences"].includes(marketingPerformance);
}
